import { buildModelManager } from "../builder.js";
const DefaultShiftProcessingSelection = {
  __typename: true,
  id: true,
  aiEvaluationMetadata: true,
  aiEvaluationResponse: { markdown: true, truncatedHTML: true },
  assignedInstructorId: true,
  auditVerdict: true,
  createdAt: true,
  emailMetadata: true,
  emailSubject: true,
  evaluationCompletedAt: true,
  evaluationStatus: true,
  fileHash: true,
  fisdapData: true,
  hitlClaimedAt: true,
  hitlClaimedBy: true,
  hitlNotified: true,
  hitlNotifiedAt: true,
  hitlOverrideAt: true,
  hitlOverrideBy: true,
  hitlOverrideVerdict: true,
  hitlRequired: true,
  hitlResolvedAt: true,
  hitlResolvedBy: true,
  hitlStatus: true,
  hitlTaskCreatedAt: true,
  isDraft: true,
  lastProcessedAt: true,
  notificationsSent: true,
  openaiResponseId: true,
  originalFile: { url: true, mimeType: true, fileName: true },
  originalFilename: true,
  pageCount: true,
  patientEncounterCount: true,
  processingStatus: true,
  processorId: true,
  reportFile: { url: true, mimeType: true, fileName: true },
  requiresReview: true,
  reviewedAt: true,
  reviewedById: true,
  reviewedInHitl: true,
  shiftId: true,
  shiftType: true,
  sourceShiftId: true,
  sourceType: true,
  structuredData: true,
  studentCohortId: true,
  studentReport: { markdown: true, truncatedHTML: true },
  submissionDate: true,
  submissionEmail: true,
  submittedById: true,
  testMode: true,
  updatedAt: true,
  userFileId: true,
  validationStatus: true
};
const modelApiIdentifier = "shiftProcessing";
const pluralModelApiIdentifier = "shiftProcessings";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftProcessingSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createShiftProcessing",
    operationReturnType: "CreateShiftProcessing",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      shiftProcessing: { required: false, type: "CreateShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkCreateShiftProcessings",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateShiftProcessingsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "updateShiftProcessing",
    operationReturnType: "UpdateShiftProcessing",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shiftProcessing: { required: false, type: "UpdateShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShiftProcessings",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateShiftProcessingsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "deleteShiftProcessing",
    operationReturnType: "DeleteShiftProcessing",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShiftProcessings",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertShiftProcessing",
    operationReturnType: "UpsertShiftProcessing",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      shiftProcessing: { required: false, type: "UpsertShiftProcessingInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateShiftProcessingResult": { hasReturnType: false },
      "... on UpdateShiftProcessingResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertShiftProcessings",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertShiftProcessingsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultShiftProcessingSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shiftProcessingGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ShiftProcessingManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShiftProcessingSelection,
  operations
);
export {
  DefaultShiftProcessingSelection,
  ShiftProcessingManager
};
//# sourceMappingURL=ShiftProcessing.js.map
